import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '@mui/material';
import React from 'react';
import useLanguage from '../../../Services/Language/useLanguageHook';
import trackingService, { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import LinkButton, { LinkButtonType } from '../../Form/Buttons/LinkButton';
import styles from './ActionModal.module.scss';

interface IActionModalProps {
    header: string;
    showModal: boolean;
    children: JSX.Element;
    actionButtonName?: string;
    secondaryActionButtonName?: string;
    handleAction?: () => void;
    handleSecondaryAction?: () => void;
    handleCancel: () => void;
    actionButtonDisabled?: boolean;
    secondaryActionButtonDisabled?: boolean;
    hideCancel?: boolean;
    track: TrackingEvent;
}

const ActionModal: React.FC<IActionModalProps> = (props: IActionModalProps) => {
    const [translations] = useLanguage();

    const handleClose = () => {
        if (props.handleCancel) {
            props.handleCancel();
        }
        trackingService.track({ eventCategory: props.track.eventCategory, eventAction: `${props.track.eventAction}Closed` });
    };

    return (
        <Modal open={props.showModal} onClose={handleClose}>
            <div className={styles.action_modal_container}>
                <div className={styles.action_modal_modal_header}>
                    <div className={styles.action_modal_modal_header_text}>{props.header}</div>
                    <CloseIcon className={styles.action_modal_close} onClick={handleClose} />
                </div>
                {props.children}
                <div className={styles.action_modal_cancel_set}>
                    {props.actionButtonName && props.handleAction && (
                        <LinkButton
                            disabled={props.actionButtonDisabled}
                            title={props.actionButtonName}
                            type={LinkButtonType.Blue}
                            onClick={props.handleAction}
                            track={{ eventCategory: props.track.eventCategory, eventAction: `${props.track.eventAction}${props.actionButtonName}Clicked` }}
                        />
                    )}
                    {props.secondaryActionButtonName && props.handleSecondaryAction && (
                        <LinkButton
                            disabled={props.secondaryActionButtonDisabled}
                            title={props.secondaryActionButtonName}
                            type={LinkButtonType.White}
                            onClick={props.handleSecondaryAction}
                            track={{
                                eventCategory: props.track.eventCategory,
                                eventAction: `${props.track.eventAction}${props.secondaryActionButtonName}Clicked`,
                            }}
                        />
                    )}
                    {!props.hideCancel && (
                        <LinkButton
                            title={translations.actions.cancel}
                            type={LinkButtonType.White}
                            onClick={props.handleCancel}
                            track={{ eventCategory: props.track.eventCategory, eventAction: `${props.track.eventAction}CancelClicked` }}
                        />
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default ActionModal;
